import {
  dashboardEmpty,
  folderEmpty,
  userEmpty,
  billEmpty,
  checkLine,
  warningLine,
  retryData,
} from '../../assets/images/Images';

export type ImageProps = {
  height: number;
  width: number;
};

const ImageSource = {
  folder_empty: folderEmpty,
  user_empty: userEmpty,
  dashboard_empty: dashboardEmpty,
  bill_empty: billEmpty,
  check_line: checkLine,
  warning_line: warningLine,
  retry_data: retryData,
};

export default ImageSource;
